import { getByPath, uniqid } from "../../tools/utils";
import type { SelectProps } from "../../types/Interface";
import { useTrads } from "../../contexts/trads/useTrads";
import type { FieldError } from "react-hook-form";


export function CivSetter({name, label, registerOutput, errors,rest, hint}:SelectProps){
    const id=uniqid(name);
    const field_errors=getByPath(errors,name) as FieldError[];
    const {translate}=useTrads()
    return (
        <>
        <div className={ "form-floating " +  (errors[name] ? " is-invalid":'')}>
                <select className={"form-select "+ (errors[name]? " is-invalid":'')} id={id}
                 aria-describedBy={hint?id + "Help":null}
                 {...registerOutput} 
                 {...rest}
                >
                    <option value="">-----</option>

                    <option value="civ_ms" >{translate('civ_ms')}</option>
                    <option value="civ_mrs"  >{translate('civ_mrs')}</option>
                    <option value="civ_other"  >{translate('civ_other')}</option>
                    <option value="civ_hidden" >{translate('civ_hidden')}</option>                    
                </select>
                <label className="form-label" htmlFor={id}>{label}</label>
               {hint?
                <small id={id + "Help"} className="form-text text-muted">{hint}</small>
            :null} 
        </div>
        {field_errors.length > 0 && <div className="invalid-feedback">{field_errors.map((error)=> 
                <p key={error.message} role="alert">{translate(error.message)}</p>)
            }</div>}
        </>
    );
}